import { render, staticRenderFns } from "./CostSend.vue?vue&type=template&id=536c30ff&scoped=true"
import script from "./CostSend.vue?vue&type=script&lang=js"
export * from "./CostSend.vue?vue&type=script&lang=js"
import style0 from "./CostSend.vue?vue&type=style&index=0&id=536c30ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c30ff",
  null
  
)

export default component.exports